import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CheckDuplicateInventoryAuditCodeQuery,
  CreateInventoryAuditBody,
  InventoryAuditApi,
  StockApi,
  UpdateInventoryAuditBody,
} from 'api';

export const findInventoryAuditStock = createAsyncThunk(
  'inventoryAudit/findInventoryAuditStock',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await InventoryAuditApi.findStock(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findInventoryAuditSeason = createAsyncThunk(
  'inventoryAudit/findInventoryAuditSeason',
  async (_, { rejectWithValue }) => {
    try {
      const response = await InventoryAuditApi.findAuditReason();
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findProductToCreateInventoryAudit = createAsyncThunk(
  'inventoryAudit/findProductToCreateInventoryAudit',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await InventoryAuditApi.findProductToCreate(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findProductToUpdateInventoryAudit = createAsyncThunk(
  'inventoryAudit/findProductToUpdateInventoryAudit',
  async (param: { id: string; option: any }, { rejectWithValue }) => {
    try {
      const { id, option } = param;

      const response = await InventoryAuditApi.findProductToUpdate(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterInventoryAudits = createAsyncThunk(
  'inventoryAudit/findInventoryAudit',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await InventoryAuditApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneInventoryAudit = createAsyncThunk(
  'inventoryAudit/findOneInventoryAudit',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await InventoryAuditApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateInventoryAuditCode = createAsyncThunk(
  'inventoryAudit/checkDuplicateInventoryAuditCode',
  async (query: CheckDuplicateInventoryAuditCodeQuery, { rejectWithValue }) => {
    try {
      const response = await InventoryAuditApi.checkDuplicate(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const generateInventoryAuditCode = createAsyncThunk(
  'inventoryAudit/generateInventoryAuditCode',
  async (_, { rejectWithValue }) => {
    try {
      const response = await InventoryAuditApi.generateCode();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createInventoryAudit = createAsyncThunk(
  'inventoryAudit/createInventoryAudit',
  async (body: CreateInventoryAuditBody, { rejectWithValue }) => {
    try {
      const response = await InventoryAuditApi.createInventoryAudit(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const exchangeInventoryAuditItem = createAsyncThunk(
  'inventoryAudit/exchangeInventoryAuditItem',
  async (param: { id: string; body: any }, { rejectWithValue }) => {
    const { id, body } = param;

    try {
      const response = await StockApi.exchangeInventoryItem(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateInventoryAudit = createAsyncThunk(
  'inventoryAudit/updateInventoryAudit',
  async (
    param: { id: string; body: UpdateInventoryAuditBody },
    { rejectWithValue }
  ) => {
    const { id, body } = param;

    try {
      const response = await InventoryAuditApi.updateInventoryAudit(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateInventoryAuditStatus = createAsyncThunk(
  'inventoryAudit/updateInventoryAuditStatus',
  async (param: { id: string; body: any }, { rejectWithValue }) => {
    const { id, body } = param;

    try {
      const response = await InventoryAuditApi.updateInventoryAuditStatus(
        id,
        body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteInventoryAudit = createAsyncThunk(
  'inventoryAudit/deleteInventoryAudit',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await InventoryAuditApi.deleteInventoryAudit(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  reasonList: Array<any>;
  tableList: Array<any>;
  orderList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  isLoaded: boolean;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: State = {
  reasonList: [],
  tableList: [],
  orderList: [],
  list: [],
  reloadFlag: false,
  isLoaded: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const inventoryAuditSlice = createSlice({
  name: 'inventoryAudit',
  initialState,

  reducers: {
    reloadInventoryAudit(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationInventoryAudit(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListInventoryAudit(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(findInventoryAuditSeason.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          key: item,
          value: item,
        };
      });

      state.reasonList = newData;
    });
  },
});

const { actions, reducer: inventoryAuditReducer } = inventoryAuditSlice;

export const {
  reloadInventoryAudit,
  updateSavedPaginationInventoryAudit,
  updateSavedListInventoryAudit,
} = actions;

export default inventoryAuditReducer;
